import { render, staticRenderFns } from "./HitPoints.vue?vue&type=template&id=c9e4bd94"
import script from "./HitPoints.vue?vue&type=script&lang=js"
export * from "./HitPoints.vue?vue&type=script&lang=js"
import style0 from "./HitPoints.vue?vue&type=style&index=0&id=c9e4bd94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports